import $axios from '@/axiosInstance.js'

export default {
	namespaced: true,
	state: {
		token: null,
		role: null,
		userid: null,
		username: null,
		at_headoffice: null,
		region_id: null,
		profiles: [],
		ordersNeedingApproval: [],
	},
	mutations: {
		setToken (state, token) {
			state.token = token
		},
		setRole (state, role) {
			state.role = role
		},
		setUserId (state, userid) {
			state.userid = userid
		},
		setUserName (state, name) {
			state.username = name
		},
		setAtHeadOffice (state, at_headoffice) {
			state.at_headoffice = at_headoffice
		},
		setRegionId (state, region_id) {
			state.region_id = region_id
		},
		setProfiles (state, profiles) {
			state.profiles = profiles
		},
		setOrdersNeedingApproval (state, jobs) {
			state.ordersNeedingApproval = jobs
		}
	},
	actions: {
		login ({ commit }, credentials) {
			return $axios.post('login', credentials)
				.then((response) => {
					console.log(response);
					commit('setToken', response.data.access_token)
					commit('setRole', response.data.userdetails.role)
					commit('setUserId', response.data.userdetails.id)
					commit('setUserName', response.data.userdetails.name)
					commit('setAtHeadOffice', response.data.userdetails.at_headoffice)
					commit('setRegionId', response.data.userdetails.region_id)
					commit('setProfiles', response.data.userdetails.profiles)
					commit('setOrdersNeedingApproval', response.data.ordersNeedingApproval)
				})
		},
		logout ({ commit }) {
			return new Promise(function (resolve, reject) {
				commit('setToken', null)
				commit('setRole', null)
				commit('setUserId', null)
				commit('setUserName', null)
				commit('setAtHeadOffice', null)
				commit('setRegionId', null)
				commit('setProfiles', null)
				delete $axios.defaults.headers.common['Authorization']
				resolve()
			})
			// commit('setToken', null)
			// commit('setRole', null)
			// delete $axios.defaults.headers.common['Authorization']
		}
	},
	getters: {
		token ({ token }) {
			return token
		},
		role ({ role }) {
			return role
		},
		userid ({ userid }) {
			return userid
		},
		username ({ username }) {
			return username
		},
		at_headoffice ({ at_headoffice }) {
			return at_headoffice
		},
		region_id ({ region_id }) {
			return region_id
		},
		profiles ({ profiles }) {
			// console.log('auth :'+profiles)
			return profiles
		},
		ordersNeedingApproval ({ ordersNeedingApproval }) {
			// console.log('auth :'+profiles)
			return ordersNeedingApproval
		},
		loggedIn ({ token }) {
			return !!token
		}
	}
}
